import { Location } from '@angular/common';
import { Injectable } from '@angular/core';
import {
    INDDGrid,
    INDDGridColumn,
    INDDGridFilterAdvancedComplexClause,
    INDDGridFilterOptions,
    INDDGridFilterSearchbarOptions,
    INDDGridHeader,
    INDDGridHeaderAction,
    NDDGridBuilder,
    NDDGridBuilderService,
    NDDGridDirectionOrder,
    NDDGridHeaderBuilder,
    NDDGridService,
} from '@ndk/ng-grid';

import { GridExportService } from '../grid-export/grid-export.service';

// TODO: Melhorar este serviço, pois não é boa prática manter serviços "utils" como forma genérica de métodos globais.
@Injectable()
export class UtilsService {
    private static GRID_PAGE_SIZE: number = 100;
    private static GRID_COLUMN_DEFAULT_MIN_RESIZABLE: number = 50;

    constructor(
        private builder: NDDGridBuilderService,
        private location: Location,
        private exportService: GridExportService,
    ) { }

    public removeUrlQueryParams(url: string): void {
        this.location.replaceState(url.substring(0, url.indexOf('?')));
    }

    public generateGridOptions(
        id: string,
        columns: INDDGridColumn[],
        sourceService: NDDGridService,
        sortByField?: string,
        pageSize?: number,
        sortDir: 'asc' | 'desc' = 'asc',
        allowCustomColumns: boolean = false,
        isGridExportable: boolean = false): INDDGrid {

        // Define valor padrão para `minResizableWidth`.
        columns.forEach((x: INDDGridColumn) => {
            if (!!x.icons || x.minResizableWidth !== undefined) { return; }

            x.minResizableWidth = UtilsService.GRID_COLUMN_DEFAULT_MIN_RESIZABLE;
        });

        const builderObj: NDDGridBuilder = this.builder.getBuilder()
            .identifier(id)
            .withPageSize(pageSize ? pageSize : UtilsService.GRID_PAGE_SIZE)
            .sortable(true)
            .selectable(true)
            .columns(columns)
            .sourceService(sourceService)
            .preserveWhitespaces(true)
            .allowCustomColumns(allowCustomColumns)
            .resizable(true)
            .allowStoreResizedColumnWidths(true);

        if (sortByField) {
            const directionOrder: NDDGridDirectionOrder = !sortDir || sortDir === 'asc' ? NDDGridDirectionOrder.ASC : NDDGridDirectionOrder.DESC;
            builderObj.sort(sortByField, directionOrder);
        }

        if (isGridExportable) {
            builderObj.withExportCSV(this.exportService);
        }

        return builderObj.build();
    }

    public generateGridHeaderOptions(
        actions: INDDGridHeaderAction[],
        searchbar?: INDDGridFilterSearchbarOptions[],
        advanced?: INDDGridFilterAdvancedComplexClause[],
        headerInfo?: string,
    ): INDDGridHeader {
        const builderObj: NDDGridHeaderBuilder = this.builder.getHeaderBuilder()
            .withDropdownText('360Actions')
            .withCancelButton('360Cancel')
            .withEditColumnDescription('360EditColumnsDescription')
            .withPdfExportDescription('360PdfExportDescription') // Necessário para ultima versão do grid
            .i18n(true);

        if (actions) {
            builderObj.actions(actions);
        }

        if (searchbar) {
            builderObj.withSearchbar(searchbar);
        }

        if (headerInfo) {
            builderObj.withHeaderInfo(headerInfo);
        }

        const options: INDDGridHeader = builderObj.build();

        if (advanced) {
            if (!options.filter) {
                options.filter = <INDDGridFilterOptions>{};
            }

            options.filter.advanced = advanced;
        }

        return options;
    }

    // tslint:disable-next-line:only-arrow-functions
    public sortByTwoColumns: Function = function (): Function {

        const fields: any[] = [].slice.call(arguments);
        const nFields: number = fields.length;

        return (A: any, B: any): any[] => {
            let a: any;
            let b: any;
            let field: any;
            let key: string;
            let desc: number;
            let result: any;

            for (let i: number = 0; i < nFields; i++) {
                result = 0;
                field = fields[i];

                key = typeof field === 'string' ? field : field.name;

                a = A[key];
                b = B[key];

                if (typeof field.primer !== 'undefined') {
                    a = field.primer(a);
                    b = field.primer(b);
                }

                desc = (field.desc) ? -1 : 1;

                if (a < b) result = desc * -1;
                if (a > b) result = desc * 1;
                if (result !== 0) break;
            }

            return result;
        };
    };
}
